import React from 'react'
import authormainheaderStyle from './AuthorMainHeader.module.css'
import brandLogo from '../../../assets/images/brandlogo.png'
import { useMediaQuery } from 'react-responsive';

export default function AuthorMainHeader(props) {

  const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

  return (
    <>
      {isMobile ? (
        <header className={authormainheaderStyle.mobilmainauthorHeader}>
          <div className={authormainheaderStyle.mobilmainauthorheaderContent}>
            <div className='container'>
              <nav className={`${authormainheaderStyle.mobilmainauthornav} ${authormainheaderStyle.mobilmainauthornavExpand} flex-wrap`}>
                <a href="/" className={`${authormainheaderStyle.mobilmainauthorheaderLeft} me-auto`}>
                  <div className={`${authormainheaderStyle.mobilmainauthorheaderBrand} d-flex align-items-center`}>
                    <img src={brandLogo} className="img-fluid" />
                    <div className={authormainheaderStyle.mobilmainauthorbrandTitles}>
                      <h6> AuthorMeet </h6>
                      <p> Powered by: Bookworm Central </p>
                    </div>
                  </div>
                </a >
                <div className={authormainheaderStyle.mobilmainauthorheaderRight}>
                  <div className={`${authormainheaderStyle.mobilmainauthorheaderbrandRight} d-flex align-items-center`}>
                    <div className={authormainheaderStyle.mobilmainauthorbrandRightIcon}>
                      <img src={brandLogo} className="img-fluid" />
                    </div>
                    <div className={authormainheaderStyle.mobilmainauthorTitleRight}>
                      <h6>{props.uname}</h6>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </header>
      ) : (
        <header className={authormainheaderStyle.mainauthorHeader}>
          <div className={authormainheaderStyle.mainauthorheaderContent}>
            <div className='container'>
              <nav className={`${authormainheaderStyle.mainauthornav} ${authormainheaderStyle.mainauthornavExpand} flex-wrap`}>
                <a href="/" className={`${authormainheaderStyle.mainauthorheaderLeft} me-auto`}>
                  <div className={`${authormainheaderStyle.mainauthorheaderBrand} d-flex align-items-center`}>
                    <img src={brandLogo} className="img-fluid" />
                    <div className={authormainheaderStyle.mainauthorbrandTitles}>
                      <h6> AuthorMeet </h6>
                      <p> Powered by: Bookworm Central </p>
                    </div>
                  </div>
                </a>
                <div className={authormainheaderStyle.mainauthorheaderRight}>
                  <div className={`${authormainheaderStyle.mainauthorheaderbrandRight} d-flex align-items-center`}>
                    <div className={authormainheaderStyle.mainauthorbrandRightIcon}>
                      <img src={brandLogo} className="img-fluid" />
                    </div>
                    <div className={authormainheaderStyle.mainauthorTitleRight}>
                      <h6>{props.uname}</h6>
                    </div>
                  </div>
                </div>
              </nav>
            </div>
          </div>
        </header>
      )}
    </>
  )
}
